import React, { Component } from "react";
import { Button } from "reactstrap";
import moment from "moment";
import ReactTable from "react-table";
import "react-table/react-table.css";
import UpdateInvoiceForm from "./updateInvoiceForm";
const columns = [
  {   
    Header: "subscription id",
    accessor: "subscription_invoice_id", // String-based value accessors!
    width: 150,
    Cell: props => (
      <span className="d-flex justify-content-center">{props.value}</span>
    )
  },
  {
    Header: "business name",
    accessor: "business_name", // String-based value accessors!
    Cell: props => (
      <span className="d-flex justify-content-center">{props.value}</span>
    )
  },
  {
    Header: "amount due",
    accessor: "amount_due", // String-based value accessors!
    width: 90,
    Cell: props => (
      <span className="d-flex justify-content-center">{props.value}</span>
    )
  },
  {
    Header: "due date",  // moment(agent["updateDate"]).format('DD-MM-YYYY')
    accessor:"due_date",
    width: 90, // String-based value accessors!
    Cell: props => (
      <span className="d-flex justify-content-center">{moment(props.value).format('DD-MM-YYYY')}</span>
    )
  },
  {
    Header: "status",
    accessor: "subscription_invoice_status_name", // String-based value accessors!
    width: 90,
    Cell: props => (
      <span className="d-flex justify-content-center">{props.value}</span>
    )
  },
  {
    Header: "C_Balance", // Custom header components!
    accessor: "current_balance",
    width: 90,
    Cell: props => (
      <div className="d-flex justify-content-center">{props.value}</div>
    )
  },

  {
    Header: "A_Paid", // Custom header components!
    accessor: "amount_paid",
    width: 90,
    Cell: props => (
      <div className="d-flex justify-content-center">{props.value}</div>
    )
  },
  {
    Header: "آپریشن ", // Custom header components!
    accessor: "operation",
    width: 90,
    Cell: props => (
      <div className="d-flex justify-content-center">{props.value}</div>
    )
  }
];

export default class ListAgentInvoice extends Component {
  state = {
    updateUserModal: false,
    subscriptionInvoiceId: ""
  };

  componentDidMount() {
   // this.getUsers();
  }

  toggle = () => {
    this.setState(prevState => ({
      updateUserModal: !prevState.updateUserModal
    }));
  };

  showUpdateModal = id => {
    this.setState({subscriptionInvoiceId: id }, () => {
    this.toggle();
    });
  };
  
  getUsers = ()=>{
    this.props.getUsers();
  }
  render() {
    let { data } = this.props;

    data.forEach(element => {
      element["operation"] = (
           <span>
          <Button
            onClick={() => {
              this.showUpdateModal(element["subscription_invoice_id"]);
            }}
            color="primary"
            className="m-1"
            // disabled={}
          >
            <i className="fas fa-file-invoice-dollar"></i>
          </Button>
          {/* <Button color="danger" className="m-1">
            <i class="fas fa-trash" aria-hidden="true"></i>
          </Button> */}
        </span>
      );
    });

    return (
      <div style={{ marginTop: "3%" }}>
        <ReactTable
          data={data}
          columns={columns}
          showPaginationTop={true}
          showPaginationBottom={false}
        />
        {this.state.subscriptionInvoiceId !== "" ? (
          <UpdateInvoiceForm
            modal={this.state.updateUserModal}
            toggle={this.toggle}
            subscriptionInvoiceId={this.state.subscriptionInvoiceId}
            getUsers={this.getUsers}
          />
          
        ) : null}
      </div>
    );
  }
}
